import classNames from "classnames";
import styles from "./card-container.less";

type CardContainerProps = {
    isPageHeight?: boolean;
    className?: string;
    children: React.ReactNode | Array<React.ReactNode>;
};

export const CardContainer = (props: CardContainerProps) => {
    const { children, className, isPageHeight } = props;

    return (
        <div className={classNames(
            styles.cardContainer,
            className ? className : "",
            isPageHeight ? styles.pageHeightCardContainer : ""
        )}>
            {children}
        </div>
    );
};